import { createValidationFunction } from "../helperFunctions";
import {
  FreeTextInput,
  PasswordInput,
  SelectInput,
  SwitchInput,
} from "../input_components";
import ImageUploadComponent from "../input_components/ImageUploadComponent";

const email = {
  label: "Email",
  toString: (data) => data.email,
  validate: createValidationFunction([
    {
      test: (data) => data.email !== "",
      feedback: "field is required",
    },
  ]),
  component: FreeTextInput,
  componentProps: { required: true },
};

const password = {
  label: "Current Password",
  toString: (data) => data.password,
  validate: createValidationFunction([
    {
      test: (data) => data.password !== "",
      feedback: "field is required",
    },
  ]),
  component: PasswordInput,
  componentProps: { required: true },
};

const newPassword = {
  label: "New Password",
  toString: (data) => data.newPassword,
  validate: createValidationFunction([
    {
      test: (data) => data.newPassword !== "",
      feedback: "field is required",
    },
    {
      test: (data) => data?.newPassword?.length >= 5,
      feedback: "too short",
    },
    {
      test: (data) => data?.newPassword?.length <= 36,
      feedback: "too long",
    },
    {
      test: (data) => data.newPassword === data.confirmNewPassword,
      feedback: "passwords must match",
    },
  ]),
  component: PasswordInput,
  componentProps: { required: true },
  revalidate: ["confirmNewPassword"],
};

const confirmNewPassword = {
  label: "Confirm New Password",
  toString: (data) => data,
  validate: createValidationFunction([
    {
      test: (data) => data.confirmNewPassword !== "",
      feedback: "field is required",
    },
    {
      test: (data) => data.newPassword === data.confirmNewPassword,
      feedback: "passwords must match",
    },
  ]),
  component: PasswordInput,
  componentProps: { required: true },
  revalidate: ["newPassword"],
};

const name = {
  label: "Name",
  toString: (data) => data.name,
  validate: createValidationFunction([
    {
      test: (data) => data.name !== "",
      feedback: "field is required",
    },
    {
      test: (data) => data.name.length <= 100,
      feedback: "too long",
    },
  ]),
  component: FreeTextInput,
  componentProps: { required: true },
};

const role = {
  label: "Role",
  toString: (data) => data.role,
  validate: createValidationFunction([
    {
      test: (data) => data.role !== "",
      feedback: "field is required",
    },
  ]),
  component: SelectInput,
  componentProps: {
    required: true,
    options: [
      { label: "Reader", value: "Reader" },
      { label: "Contributor", value: "Contributor" },
      { label: "Editor", value: "Editor" },
      { label: "Administrator", value: "Administrator" },
    ],
  },
};

const active = {
  label: "Active",
  toString: (data) => (data.active ? "True" : "False"),
  validate: createValidationFunction([]),
  component: SwitchInput,
};

const avatar = {
  label: "Avatar",
  toString: (data) => data?.avatar?.url,
  validate: createValidationFunction([]),
  component: ImageUploadComponent,
};

export const schema = {
  email,
  password,
  newPassword,
  confirmNewPassword,
  name,
  role,
  active,
  avatar,
};

export const blankForm = {
  email: "",
  name: "",
  role: "",
  active: false,
};
